import React from 'react';
import { useSettings } from '../context/SettingsContext';

export default function Footer() {
  const { hotelName } = useSettings();

  return (
    <footer className='bg-gray-900 text-white mt-auto'>
      <div className='max-w-7xl mx-auto px-4 py-8 text-center'>
        <p className='text-2xl font-bold mb-2'>{hotelName || 'HotelDelish'} 🍽️</p>
        <p className='text-gray-400 mb-2'>Delicious meals delivered to your table</p>
        <p className='text-sm text-amber-400 mb-4'>
          For application & support: <a href='mailto:solapurdeals@gmail.com' className='underline hover:text-amber-300 transition-colors font-medium'>solapurdeals@gmail.com</a>
        </p>
        <p className='text-gray-500 text-sm'>
          © {new Date().getFullYear()} {hotelName || 'HotelDelish'}. All rights reserved.
        </p>
      </div>
    </footer>
  );
}

